import { render, staticRenderFns } from "./Line.vue?vue&type=template&id=130b4389&scoped=true&"
import script from "./Line.vue?vue&type=script&lang=js&"
export * from "./Line.vue?vue&type=script&lang=js&"
import style0 from "./Line.vue?vue&type=style&index=0&id=130b4389&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130b4389",
  null
  
)

export default component.exports